import actions from "./actions";

const initState = {
    readContactAddressState: null,
    contactAddresses: [],
    requestedProductId: null,
};

export default function authReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CONTACT_ADDRESSES_READ_REQUEST:
            return {
                ...state,
                requestedContactId: action.contactId || null,
                readContactAddressState: 'request',
            };
        case actions.CONTACT_ADDRESSES_READ_SUCCESS: {
            // Process response data
            const { responseData } = action;

            return {
                ...state,
                contactAddresses: responseData.items,
                readContactAddressState: 'success',
            };
        }
        default:
            return state;
    }
}
